import { DataGridPremium } from "@mui/x-data-grid-premium";
import { useGetTransactionTypesQuery, useGetTransactionsPagedQuery } from "../../../services/PaymentToolApi";
import { useState } from "react";
import { Box, Button, Typography } from '@mui/material';
import { formatMoney } from "../../../utils";
import { IconButton, Tooltip } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import EditTransactionModal from "../payoutManagement/PaymentsToolGrids/components/EditTransactionModal";
import { parseToEasternTime } from "../../../utils/dates";
import AddUserErrorTransactionModal from "../payoutManagement/PaymentsToolGrids/components/AddUserErrorTransactionModal";
import { useGetErrorTrackingPagedWithRelatedTransactionsQuery } from "../../../services/errorTrackingApi";
import EditUserErrorTransactionModal from "../payoutManagement/PaymentsToolGrids/components/EditUserErrorTransactionModal";

export default function UserErrorTransactions({ user }) {
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [openEditTransactionModal, setOpenEditTransactionModal] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(null);

  const {data: errorTracking, isLoading: isLoadingErrorTracking, isFetching: isFetchingErrorTracking, error: errorErrorTracking} = useGetErrorTrackingPagedWithRelatedTransactionsQuery({
    userID: user.id,
    isDeleted: false
  },
    {
      skip: !user.id
    }
  );

  function getErrorTransactionID(row){
    if(row.relatedTransactions && row.relatedTransactions.length > 0){
      return row.relatedTransactions[0].id
    }
    return "-"
  }

  function getRelatedTransactionEventName(row){
    if(row.relatedTransactions && row.relatedTransactions.length > 0){
      return row.relatedTransactions[0].eventName
    }
    return "-"
  }

  function getRelatedTransactionEventVenue(row){
    if(row.relatedTransactions && row.relatedTransactions.length > 0){
      return row.relatedTransactions[0].eventVenue
    }
    return "-"
  }

  function getRelatedTransactionEventDate(row){
    if(row.relatedTransactions && row.relatedTransactions.length > 0){
      return row.relatedTransactions[0].eventDate
    }
    return "-"
  }

  function getRelatedTransactionId(row){
    if(row.relatedTransactions && row.relatedTransactions.length > 0){
      return row.relatedTransactions[0].relatedTransactionID
    }
    return "-"
  }
// --------------------------------------------------------------------------------------------------------------
  function getRelatedBuyType(row){
    if(row.relatedTransactions && row.relatedTransactions.length > 0){
      return row.buyTypeName
    }
    return "-"
  }
// --------------------------------------------------------------------------------------------------------------

  function GetAmount({row}){

    if(row.relatedTransactions && row.relatedTransactions.length > 0){
      return<p style={{ color: 'red' }}>{ "-" + formatMoney(row.relatedTransactions[0].amount)} </p>
    }
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%' }}>
      <Typography textAlign="center"> - </Typography>
    </div>
  }

  const [columns, setColumns] = useState([

    // { headerName: 'ERROR ID', field: 'id', width: 80 },
    // { headerName: 'ERROR TRANSACTION ID', field: 'transactionID', width: 80, valueGetter: (params) => getErrorTransactionID(params.row)},
    {
      headerName: 'REASON', field: 'reason', flex: 1, renderCell: (params) => (
        <Tooltip 
        title={
          params.row.errorReasonName !== "Other" 
            ? params.row.errorReasonName + (params.row.notesForBee ? ", " + params.row.notesForBee : "")
            : (params.row.notesForBee || "N/A")
        }
        >
          <span>{params.row.errorReasonName == "Other" ? params.row.notesForBee : params.row.errorReasonName}</span>
        </Tooltip>
      ),
    },
    {
      headerName: 'INTERNAL NOTES', field: 'notesForAdmin', flex: 1,
      renderCell: (params) => (
        <Tooltip 
          title={params.row.notesForAdmin}
        >
          <span>{params.row.notesForAdmin}</span>
        </Tooltip>
      ),
    },
    {
      headerName: 'REPORTED ON', field: 'createdOn', width: 130, valueGetter: (params) => parseToEasternTime(params.row.createdOn),
    },
    {
      field: 'buyType', headerName: 'BUY TYPE', width: 80, headerAlign: 'center', align: 'center', valueGetter: (params) => getRelatedBuyType(params.row)
    },
    {
      headerName: 'EVENT NAME', field: 'eventName', flex: 0.75,valueGetter: (params) => getRelatedTransactionEventName(params.row)
    },
     {
       headerName: 'EVENT VENUE', field: 'eventVenue', flex: 1,valueGetter: (params) => getRelatedTransactionEventVenue(params.row)
     },
    {
      headerName: 'RELATED TRANSACTION', field: 'relatedTransactionID', width: 80, valueGetter: (params) => getRelatedTransactionId(params.row)
    },
    // {
    //   headerName: 'EVENT DATE', field: 'eventDate', flex: 1, valueGetter: (params) => getRelatedTransactionEventDate(params.row)
    // },
   
    {
      headerName: 'AMOUNT', field: 'amount', width: 80, renderCell: (params) => <GetAmount row={params.row} />
    },
    
    {
      field: 'buttons',
      headerName: '',
      width: 50,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => (
        <Tooltip title="Edit Transaction" placement="top-start">
          <IconButton
            onClick={() => { setOpenEditTransactionModal(true); setSelectedTransaction(params.row); }}
            variant="contained"
            size="small"
            color='primary'
          >
            <EditOutlinedIcon />
          </IconButton>
        </Tooltip>
      )
    },
  ]);

  if (errorErrorTracking) {
    return <p>Error: {JSON.stringify(errorErrorTracking)}</p>;
  }

  function onPaginationChangeHandler({ page, pageSize }) {
    setPageNumber(page + 1); //A: the pagination starts in 0, but the api starts in 1
    setPageSize(pageSize);
  }

  return (
    <Box sx={{ height: 425, width: '100%', margin: '0', padding: '0' }}>

      <AddUserErrorTransactionModal selectedUser={user} modalIsOpen={modalIsOpen} setModalIsOpen={setModalIsOpen} />
      <EditUserErrorTransactionModal selectedUser={user} selectedTransaction={selectedTransaction} modalIsOpen={openEditTransactionModal} setModalIsOpen={setOpenEditTransactionModal} />

      <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', margin: '0 0 0.5em 0' }} >
        <Button variant="outlined" onClick={() => setModalIsOpen(true)}>Add Error</Button>
      </div>
      
      <DataGridPremium
        sx={{ height: '95%' }}
        headerHeight={40}
        rowHeight={36}
        rows={(errorTracking?.items || [])} columns={columns}
        loading={isLoadingErrorTracking || isFetchingErrorTracking}
        disableSelectionOnClick
        pagination
        paginationMode="server"
        rowCount={errorTracking?.totalCount || 0}
        onPaginationModelChange={onPaginationChangeHandler}
        page={pageNumber - 1} //A: the pagination starts in 0, but the api starts in 1
        pageSize={pageSize}
      />
    </Box>
  );
}